import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { CreatureStats, EncounterStats, RowObject } from '../../Types/TableTypes';
import TableRowBottomComponent from './TableRowBottomComponent';
import TableRowTopComponent from './TableRowTopComponent';

interface TableRowComponentProps {
    row: RowObject,
    index: number,
    isPlayer: boolean,
    initiativeBonus: number,
    rerenderRow: ()=>void 
    deleteRow: (index: number)=>void 
    duplicateRow: (index: number)=>void 
    updateIndex: (index: number, delta: number)=>void 
    isCurrentTurn: boolean
    editMode: boolean
}

const TableRowComponent = (props: TableRowComponentProps)=>{
    const [encounterStats, setEncounterStats] = useState(props.row.encounterStats);
    const [creatureStats, setCreatureStats] = useState(props.row.creatureStats);
    
    useEffect(() => {
            setEncounterStats(props.row.encounterStats);
            setCreatureStats(props.row.creatureStats);
        }, [props.row.encounterStats, props.row.creatureStats, encounterStats, creatureStats]);

    const updateEncounterStats = useCallback((stats: EncounterStats) => {
        setEncounterStats({...stats});
        props.row.encounterStats = stats;
        console.log(stats);
    },[props]);
    
    const updateCreatureStats = useCallback((stats: CreatureStats) => {
        setCreatureStats({...stats});
        props.row.creatureStats = stats;
    },[props.row]);

    const updateExpanded = (newExpanded: boolean) => {
        setEncounterStats({...encounterStats, expanded: newExpanded});
        if (newExpanded !== props.row.encounterStats.expanded){
            props.row.encounterStats.expanded = newExpanded;
            props.rerenderRow()
        }else{
            props.row.encounterStats.expanded = newExpanded;
        }
    }
    // console.log("rowcomp");
    return(
        <>
            <TableRowTopComponent 
                // key={"creature-"+props.index}
                row={encounterStats} 
                index={props.index} 
                isPlayer={creatureStats.isPlayer}
                initiativeBonus={creatureStats.initiativeBonus}
                updateRow={updateEncounterStats} 
                deleteRow={props.deleteRow} 
                duplicateRow={props.duplicateRow} 
                updateIndex={props.updateIndex}
                isCurrentTurn={props.isCurrentTurn}
                editMode={props.editMode}
                // expanded={(props.row.encounterStats.expanded && (props.editMode || !props.row.creatureStats.isPlayer))}
                updateExpanded={updateExpanded}
            />
            <TableRowBottomComponent
                // key={"block-"+props.index}
                // index={props.index} 
                creatureStats={creatureStats} 
                updateCreatureStats={updateCreatureStats}
                editMode={props.editMode} 
                expanded={(props.row.encounterStats.expanded && (props.editMode || !props.row.creatureStats.isPlayer))}/>
        </>
    )
}

export default TableRowComponent;